import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { LoadingStatesState } from "../types/loadingStatesTypes";

const initialState: LoadingStatesState = {
  appReplayLoading: false,
  storeScreenLoading: false,
  appVideoAnimationLoading: false,
  webOnboardingLoading: false,
  anythingSearchLoading: false,
  searchScreenLoading: false,
  similarScreenLoading: false,
  imageSearchLoading: false,
};

const loadingStatesSlice = createSlice({
  name: "loadingStates",
  initialState,
  reducers: {
    setAppReplayLoading: (state, action: PayloadAction<boolean>) => {
      state.appReplayLoading = action.payload;
    },
    setStoreScreenLoading: (state, action: PayloadAction<boolean>) => {
      state.storeScreenLoading = action.payload;
    },
    setAppVideoAnimationLoading: (state, action: PayloadAction<boolean>) => {
      state.appVideoAnimationLoading = action.payload;
    },
    setWebOnboardingLoading: (state, action: PayloadAction<boolean>) => {
      state.webOnboardingLoading = action.payload;
    },
    setAnythingSearchLoading: (state, action: PayloadAction<boolean>) => {
      state.anythingSearchLoading = action.payload;
    },

    setSearchScreenLoading: (state, action: PayloadAction<boolean>) => {
      state.searchScreenLoading = action.payload;
    },
    setSimilarScreenLoading: (state, action: PayloadAction<boolean>) => {
      state.similarScreenLoading = action.payload;
    },
    setImageSearchLoading: (state, action: PayloadAction<boolean>) => {
      state.imageSearchLoading = action.payload;
    },
  },
});

export const { actions: loadingStatesActions, reducer: loadingStatesReducer } =
  loadingStatesSlice;
